// Tyler.API.Common.Interfaces.ActionType
export enum ActionType {
    ServerUrl = 1,
    Url = 2,
    Html = 3,
    Server = 4,
    Dialog = 5,
    Packet = 6,
    Share = 7,
    Popup = 8,
    Intent = 9,
    Metadata = 10,
    Export = 11,
    Notes = 12,
    Attachments = 13
}
